import React from 'react';
import ClaimsSelectionFieldYearOnly from '@rd-web-markets/shared/dist/company/kimble/ClaimsSelectionFieldYearOnly';
const ClaimSelectionField = _ref => {
  let {
    toggleInclude,
    claims,
    toggleForm,
    includeSingleClaim,
    loading,
    setFromDate,
    setClaims
  } = _ref;
  return /*#__PURE__*/React.createElement(ClaimsSelectionFieldYearOnly, {
    toggleInclude: toggleInclude,
    claims: claims,
    includeSingleClaim: includeSingleClaim,
    loading: loading,
    setFromDate: setFromDate,
    setClaims: setClaims
  });
};
export default ClaimSelectionField;